import { useEffect } from "react"
import { Button, IconButton } from "web/components"
import useAddTileWizard from "../AddTileWizard/useAddTileWizard"
import { pluralize } from "web/services/inflector"

export default function CurrentTemplateManager({
  currentOverview,
  handleTemplateReset,
  canSelect,
  canEdit,
  subjectType,
  subjectId,
  genericTileFetchParams,
  overviewFetchParams,
  editPath,
  exportPath,
}) {
  const addTile = useAddTileWizard({
    genericTileFetchParams,
    overviewFetchParams,
    subjectType,
    subjectId,
  })

  async function handleAddTile() {
    await addTile()
    currentOverview.refresh()
  }

  useEffect(() => {
    function handleOpenWizard() {
      currentOverview.refresh()
      handleAddTile()
    }

    window.addEventListener(
      "event-dispatcher:open-add-tile-wizard",
      handleOpenWizard
    )
    return () =>
      window.removeEventListener(
        "event-dispatcher:open-add-tile-wizard",
        handleOpenWizard
      )
  })

  const pdfURL =
    exportPath ||
    `/${pluralize(subjectType)}/${subjectId}/selected_overview.pdf`

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex w-full flex-grow flex-wrap items-baseline gap-2 sm:w-fit sm:flex-grow-0">
        {currentOverview.name}
        {canSelect ? (
          <a
            href={editPath}
            data-turbo-frame="modal"
            className="text-sm text-blue-500 hover:text-blue-800 hover:underline"
          >
            Change Overview
          </a>
        ) : null}
      </div>
      {currentOverview.modified_from_template && (
        <div className="flex gap-2 rounded-full bg-neutral-9 px-3 py-1 text-sm">
          <div className="text-neutral-4">Modified</div>
          {canEdit && (
            <button
              className="text-blue-500 hover:text-blue-800 hover:underline"
              onClick={handleTemplateReset}
            >
              Reset
            </button>
          )}
        </div>
      )}
      <div className="flex flex-grow items-end justify-end gap-x-2.5">
        <div>
          <a href={pdfURL}>
            <IconButton outline name="document-arrow-down" />
          </a>
        </div>
        <div>
          {canEdit && (
            <Button
              onClick={handleAddTile}
              variant="secondary_default"
              size="small"
            >
              Add Tile
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
